import React, { useEffect } from "react";
import axios from "axios";
import { API_BASE_URL, API_URLS, LOCALSTORAGE_TOKEN_ITEM } from "constants/api";
import { Platform } from "types/platform";

export const usePlatforms = () => {
  const [platforms, setPlatforms] = React.useState<Platform[]>([]);
  const [fetching, setFetching] = React.useState(true);
  const token = localStorage.getItem(LOCALSTORAGE_TOKEN_ITEM);

  useEffect(() => {
    (async () => {
      try {
        setFetching(true);
        const response = await axios.get(
          `${API_BASE_URL}${API_URLS.Platforms}`,
          { headers: { Accept: 'application/json', Authorization: `Bearer ${token}` } }
        );
        setPlatforms(response.data.data);
      } catch (e) {
        console.error(e);
      } finally {
        setFetching(false);
      }
    })();
  }, []);
  return { platforms, fetching };
};
